// extracted by mini-css-extract-plugin
export default {"Godly":"roles_Godly__3OuOt","Default":"roles_Default__j-D7p"};